import axios from "axios"
const deleteAccount = body => {
  return axios
    .post("/panel/delete-account", body)
    .then(response => {
      console.log("response from server", response.status, response.data)
      return response.data
    })
    .catch(response => {
      //acctions in case of error in server
      console.log("rerrr", response)
      return null
    })
}
const newProfile = () => {
  return axios
    .get("/panel/new-profile")
    .then(response => {
      console.log("response from server", response.status, response.data)
      return response.data
    })
    .catch(response => {
      //acctions in case of error in server
      console.log("rerrr", response)
      return null
    })
}

const changeKProfile = profileId => {
  const body = {
    profileId: profileId,
  }
  return axios
    .post("/panel/change-k-profile", body)
    .then(response => {
      console.log("response from server", response.status, response.data)
      return response.data
    })
    .catch(response => {
      //acctions in case of error in server
      console.log("rerrr", response)
      return null
    })
}

const getUserWithToken = token => {
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  }

  return axios
    .get("/klauspanel_auth/token", { headers })
    .then(response => {
      console.log("response from token auth", response.status)
      if (response.status == 200) {
        console.log("TOKEn", localStorage.getItem("klausToken"), token)
        axios.defaults.headers.common["Authorization"] = `Bearer ${token}`
      }
      return response.data
    })
    .catch(response => {
      //acctions in case of error in server
      console.log("rerrr", response)
      return null
    })
}
const logIn = (username, pass) => {
  //body
  const body = { username, password: pass }
  const headers = {
    "Content-Type": "application/json",
    //Authorization: `Bearer ${token}`,
  }

  return axios
    .post("/login_auth", body, {
      headers: headers,
    })
    .then(response => {
      console.log("response from server", response.status, response.data)
      if (response.status == 200) {
        axios.defaults.headers.common[
          "Authorization"
        ] = `Bearer ${response.data.auth_token}`
      }
      return response.data
    })
    .catch(response => {
      //acctions in case of error in server
      console.log("rerrr", response)
      return null
    })
}

const requestCODE = (phone, selected_country, reference, sms) => {
  //body
  const body = {
    phone,
    selected_country: selected_country,
    profile_ref: reference,
    sms: sms,
  }
  const headers = {
    "Content-Type": "application/json",
    //Authorization: `Bearer ${token}`,
  }
  console.log(body, phone, selected_country)
  return axios
    .post("/klauspanel_auth", body, {
      headers: headers,
    })
    .then(response => {
      console.log("response from server", response.status, response.data)
      if (response.status == 200) {
        /* axios.defaults.headers.common[
          "Authorization"
        ] = `Bearer ${response.data.auth_token}` */
      }
      return response.data
    })
    .catch(response => {
      //acctions in case of error in server
      console.log("rerrr", response)
      return null
    })
}

export default {
  logIn,
  getUserWithToken,
  requestCODE,
  changeKProfile,
  newProfile,
  deleteAccount,
}
